import _includes from "lodash/includes"

const testSequence = (value) => {
  const onlyNumbers = /^\d+$/.test(value)

  if (!onlyNumbers) {
    console.error("O valor inputado precisa conter apenas números")
    return false
  }

  if (value.length > 8) {
    value = value.slice(1, value.length)
  }

  const digits = value.split("")
  let valid = true

  for (let i = 0; i < digits.length - 1; i++) {
    if (Math.abs(Number(digits[i]) - Number(digits[i + 1])) > 1) {
      if (i + 1 >= 6 && digits[i + 1] === "0") {
        valid = true
      } else {
        valid = false
        break
      }
    }
  }

  return valid
}

export const validatePhone = (phone) => {
  if (!phone) {
    return false
  }

  const validDdd = [
    11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35,
    37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64,
    65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88,
    89, 91, 92, 93, 94, 95, 96, 97, 98, 99
  ]

  const payloadDdd = phone ? phone.slice(0, 2) : 0
  const validateDdd = _includes(validDdd, +payloadDdd)

  if (!validateDdd) {
    return false
  }

  const phoneNumber = phone ? phone.slice(2, phone.length) : ""

  const repeatedNumbersPattern = /([0-9])\1{7,}/gi
  const validPhoneLength = phoneNumber.length > 7 && phoneNumber.length < 10
  const validateRepeatedNumbers = repeatedNumbersPattern.test(phoneNumber)
  const validateSequencialNumbers = testSequence(phoneNumber)

  return (
    validPhoneLength && !validateRepeatedNumbers && !validateSequencialNumbers
  )
}



// WEBPACK FOOTER //
// ./src/services/utils/phoneValidation.js